module.exports = __webpack_public_path__ + "static/img/passionate.34dc404.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand-culture/passionate.png
// module id = HqUD
// module chunks = 1